<template>
    <div>
        <b-modal 
            :title="titleModal" 
            :id="`modal-${id}`" 
            size="xl" 
            scrollable 
            @ok="ok" 
            @hidden="$emit('cancel')" 
            @cancel="cancelar" 
            :cancel-variant="removeEnabled && remove ? 'outline-danger' : 'outline-secondary'" 
            :ok-variant="(okDisabled && removeEnabled) || okCancel ? 'secondary' : 'success'"
            :hide-footer="!controles || esconderBotoesModal"  
            :ok-disabled="okDisabled"       
            :ok-only="somenteOk"   
            >
            <slot name="modal" />
            <template #modal-ok>
                <i class="fa-solid fa-check mr-2" v-if="!okCancel"></i>
                {{!okCancel ? 'Salvar' : 'Fechar'}}
            </template>
            <template #modal-cancel>
                <i class="fa-solid fa-times mr-2"></i>
                {{removeEnabled && remove ? 'Excluir' : 'Fechar'}}
            </template>
            <template #modal-title>
                <slot name="title">
                    {{titleModal}}
                </slot>
            </template>
        </b-modal>

        <div>
            <div class="d-inline-flex align-content-center" v-if="title != '' || (!hideButton && controles && create)">
                <h4 style="line-height: 35px;" v-if="title != ''">{{title}}</h4>
                <div class="ml-2 mb-2" v-if="!hideButton &&controles && create">
                    <b-button :variant="variantButton" :size="sizeButton" @click="openModal">
                        <i class="fa-solid fa-plus mr-2"></i>
                        {{placeholderButton}}
                    </b-button>
                </div>
            </div>

            <slot name="beforeTable" ></slot>
            
            <slot name="table">
                <accordion
                    :id="`${accordionId}-fix`" 
                    :title="accordionTitle"
                    sub
                    :accordion="accordionId"
                    :hideTitle="accordionTitle == ''"
                    visible
                    :no-border-collapse="!borderCollapse"
                >
                    <template #append-title>
                        <div class="d-flex justify-content-between">
                            <b-button :variant="variantButton"  v-if="controles && create" class="ml-2" @click="clicado" size="sm">
                                <i class="fa-solid fa-plus mr-1"></i>
                                {{placeholderButton}}
                            </b-button>
                            <slot name="after-button"></slot>
                        </div>
                    </template>
                    
                    
                    <div :class="accordionTitle != '' ? 'p-3' : ''"    >
                        <div v-if="!isGantt" class="table-responsive">
                            <b-table @row-dblclicked="abrirEditar" head-variant="dark" hover :items="values" :fields="fields" >
                                <template v-slot:[`cell(${slotImage})`]="data">
                                    <b-avatar  :src="data.value"></b-avatar>
                                </template>
                                <template #cell(edit)="data">
                                    <b-button variant="flat-primary" class="mr-2" v-if="controles && update && updateVerificacao(data.item)" @click="$emit('edit', data.item)"><i class="fas fa-edit"></i></b-button>
                                </template>
                                <template #cell(remove)="data">
                                    <b-button  v-if="controles && remove && deleteVerificacao(data.item)" variant="flat-danger" class="mr-2" @click="$emit('remove', data.item)"><i class="fas fa-trash"></i></b-button>
                                </template>
                                <template  #cell(actions)="data">
                                    <slot name="info-extra" v-if="!updateVerificacao(data.item) && !deleteVerificacao(data.item)"></slot>
                                    <div v-if="controles" class="d-inline-flex">
                                        <slot name="buttons" v-bind:data="data">
                                            <slot name="buttons-prepend" v-bind:data="data.item"></slot>
                                            <b-button variant="flat-primary" class="mr-2" v-if="update && updateVerificacao(data.item)" @click="$emit('edit', data.item)"><i class="fas fa-edit"></i></b-button>
                                            <b-button variant="flat-danger" class="mr-2" v-if="remove && deleteVerificacao(data.item)" @click="$emit('remove', data.item)"><i class="fas fa-trash"></i></b-button>
                                            <slot name="buttons-append" v-bind:data="data.item"></slot>
                                        </slot>
                                    </div>
                                </template>
                            </b-table>
                        </div>

                        <gantt-chart v-if="isGantt" :is-multiple="isGanttMultiple" :cols="fields" :rows="values" @click="rowClick"/>
                    </div>
                </accordion>
            </slot>
        </div>

    </div>
</template>
<script>

//import Swal from "sweetalert2";
import GanttChart from '@/components/charts/GanttChart.vue'
import Accordion from '@/components/card/Accordion';

export default {
    emits : ['ok','rowClick'],
    props : {
        id: {
            type: String,
            default: null,
        },
        fields: {
            type: Array,
            default: () => [],
        },
        values : {
            type : Array,
            default : () => []
        },
        placeholderButton : {
            type : String,
            default : ""
        },
        variantButton : {
            type : String,
            default : "info"
        },
        sizeButton : {
            type : String,
            default : ""
        },
        title : {
            type : String,
            default : ""
        },
        slotImage : {
            type : String,
            default : "avatar"
        },

        create : {
            type : Boolean,
            default : false
        },
        update : {
            type : Boolean,
            default : false
        },
        read : {
            type : Boolean,
            default : false
        },
        remove : {
            type : Boolean,
            default : false
        },
        isGantt : {
            type : Boolean,
            default : false
        },
        isGanttMultiple : {
            type : Boolean,
            default : false
        },
        titleModal: {
            type : String,
            default : ""
        },
        removeEnabled : {
            type : Boolean,
            default : false
        },
        okDisabled : {
            type : Boolean,
            default : false
        },
        controles : {
            type:Boolean,
            default:true
        },
        updateVerificacao : {
            type : Function,
            default : () => {
                return true
            }
        },
        deleteVerificacao : {
            type : Function,
            default : () => {
                return true
            }
        },
        hideButton : {
            type : Boolean,
            default : false
        },

        //accordion
        accordionTitle : {
            type : String,
            default : ""
        },
        accordionId : {
            type : String,
            default : ""
        },
        borderCollapse : {
            type : Boolean,
            default : false
        },

        esconderBotoesModal : {
            type : Boolean,
            default : false
        },
        okCancel : {
            type : Boolean,
            default : false
        },
        somenteOk : {
            type : Boolean,
            default : false
        }
    },
    components : {
        GanttChart,
        Accordion
    },
    data : () => ({}),
    methods:{
        abrirEditar(item){
            if(this.controles && this.update && this.updateVerificacao(item))
                this.$emit('edit', item)
        },
        cancelar : function(e){
            if(this.removeEnabled && this.remove){
                e.preventDefault();
                this.$emit('remove')
            } else {
                this.$emit('cancel')
            }
        },
        openModal: function(){
            return new Promise((resolve) => {
                this.$bvModal.show('modal-' + this.id);
                this.$nextTick(() => {
                    resolve()
                })
            })
            
        },

        closeModal: function(){
            this.$nextTick(() => {
                this.$bvModal.hide('modal-' + this.id);                
            })
        },

        ok: function(e){ 
            e.preventDefault();
            if(this.okCancel){
                this.closeModal();
            }else{
                this.$emit("ok");
            }
        },
        rowClick: function(item){
            this.$emit("rowClick", item);
        },
        clicado(e) {
            e.stopPropagation();
            this.openModal();
        }
    },
    mounted: function(){
    },
    watch : {
        
    }

};
</script>
<style>
    .card, .table-responsive {
        min-height: inherit !important;
    }
    
    .table-warning .btn {
        display: none !important;
    }
</style>